

export const getLoggedInUserName = () => {
    try {
        // Get token from localStorage
        const token = localStorage.getItem('jwtToken');
        
        if (!token) {
            console.warn('No JWT token found in localStorage');
            return "DefaultUser";
        }
        
        // Split the token and make sure it has three parts
        const tokenParts = token.split('.');
        if (tokenParts.length !== 3) {
            console.warn('JWT token does not have three parts');
            return "DefaultUser";
        }
        
        try {
            // Decode the JWT token payload (middle part)
            const payload = JSON.parse(atob(tokenParts[1]));
            
            // Check for various possible fields that might contain the user name
            // This handles different JWT formats that may be used
            if (payload && payload.firstName) {
                return payload.firstName; 
            } 
            
            if (payload && payload.name) {
                // Sometimes name might be "First Last", so split and take first part
                const nameParts = payload.name.split(' ');
                return nameParts[0];
            }
            
            if (payload && payload.username) {
                return payload.username;
            }
            
            if (payload && payload.sub) {
                // sub might contain email or username
                const subParts = payload.sub.split('@');
                return subParts[0]; // Return part before @ if it's an email
            }
            
            if (payload && payload.email) {
                const emailParts = payload.email.split('@');
                return emailParts[0];
            }
            
            // If we get here, we have a token but couldn't find a suitable field
            console.warn('No suitable user identifier found in token payload');
            return "DefaultUser";
        } catch (decodeError) {
            console.error('Error decoding token payload:', decodeError);
            return "DefaultUser";
        }
    } catch (error) {
        console.error('Unexpected error getting user name:', error);
        return "DefaultUser";
    }
}